/* RESPONSIBLE TEAM: team-self-serve */

import Model, { attr } from '@ember-data/model';

export default class ModelTrainingConsentOptOutRequest extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare optOutReason: string;
  @attr('string') declare requesterRole: string;
  @attr('date') declare requestedAt: Date;
  @attr('string') declare requestedBy: string;
  @attr('boolean') declare approved: boolean;
}
